export default __webpack_public_path__ + "static/media/foul.b7a91c12.png";